(function () {
  'use strict';

  var ACCORDION_FALLBACK_MS = 550;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function clearDisclosureTimer(panel) {
    if (!panel) return;
    if (panel._disclosureTimer) {
      window.clearTimeout(panel._disclosureTimer);
      panel._disclosureTimer = null;
    }
    if (panel._disclosureHandler) {
      panel.removeEventListener('transitionend', panel._disclosureHandler);
      panel._disclosureHandler = null;
    }
  }

  function setDisclosure(panel, open, instant) {
    if (!panel) return;
    clearDisclosureTimer(panel);
    instant = instant || prefersReducedMotion();

    if (open) {
      panel.hidden = false;
      if (instant) {
        panel.classList.add('is-open');
        return;
      }
      panel.classList.remove('is-open');
      void panel.offsetHeight;
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      return;
    }

    panel.classList.remove('is-open');
    if (instant || panel.hidden) {
      panel.hidden = true;
      return;
    }

    function finish(event) {
      if (event && event.target !== panel) return;
      if (event && event.propertyName && event.propertyName !== 'grid-template-rows') {
        return;
      }
      clearDisclosureTimer(panel);
      panel.hidden = true;
    }

    panel._disclosureHandler = finish;
    panel.addEventListener('transitionend', finish);
    panel._disclosureTimer = window.setTimeout(finish, ACCORDION_FALLBACK_MS);
  }

  function closeAllAccordions(footer, instant) {
    var toggles = footer.querySelectorAll('[data-accordion-toggle]');
    var panels = footer.querySelectorAll('[data-accordion-panel]');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    panels.forEach(function (panel) {
      setDisclosure(panel, false, instant);
    });
  }

  function bindAccordion(footer) {
    if (!footer || footer.dataset.accordionBound === 'true') return;
    footer.dataset.accordionBound = 'true';

    var toggles = footer.querySelectorAll('[data-accordion-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
        closeAllAccordions(footer, false);

        if (willOpen) {
          toggle.setAttribute('aria-expanded', 'true');
          setDisclosure(panel, true, false);
        }
      });
    });
  }

  function closeLocaleSwitcher(footer) {
    var switchers = footer.querySelectorAll('[data-locale-switcher]');
    switchers.forEach(function (switcher) {
      var trigger = switcher.querySelector('[data-locale-trigger]');
      var menu = switcher.querySelector('[data-locale-menu]');
      switcher.setAttribute('data-open', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    });
  }

  function bindLocaleSwitcher(footer) {
    if (!footer || footer.dataset.localeBound === 'true') return;
    footer.dataset.localeBound = 'true';

    var switchers = footer.querySelectorAll('[data-locale-switcher]');
    switchers.forEach(function (switcher) {
      var trigger = switcher.querySelector('[data-locale-trigger]');
      var menu = switcher.querySelector('[data-locale-menu]');
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function () {
        var willOpen = switcher.getAttribute('data-open') !== 'true';
        closeLocaleSwitcher(footer);
        if (willOpen) {
          switcher.setAttribute('data-open', 'true');
          trigger.setAttribute('aria-expanded', 'true');
          menu.hidden = false;
        }
      });
    });
  }

  function bindNewsletter(footer) {
    var input = footer.querySelector('[data-newsletter-input]');
    var submit = footer.querySelector('[data-newsletter-submit]');
    if (!input || !submit || input.dataset.newsletterBound === 'true') return;
    input.dataset.newsletterBound = 'true';

    function sync() {
      submit.disabled = input.value.trim() === '';
    }

    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  }

  function initFooter(footer) {
    if (!footer) return;
    footer.dataset.accordionBound = '';
    footer.dataset.localeBound = '';
    bindAccordion(footer);
    bindLocaleSwitcher(footer);
    closeLocaleSwitcher(footer);
    bindNewsletter(footer);
  }

  function findFooter() {
    return document.querySelector('[data-footer]');
  }

  function init() {
    initFooter(findFooter());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var footer = event.target.querySelector
      ? event.target.querySelector('[data-footer]')
      : null;
    if (!footer && event.target.matches && event.target.matches('[data-footer]')) {
      footer = event.target;
    }
    if (footer) initFooter(footer);
  });
})();
